import React from 'react'
import { FaArrowRight } from 'react-icons/fa';
import { IoIosSearch } from 'react-icons/io';
import { Link } from 'react-router-dom';
import { useAuth } from '../../Context/ContextProvider';
import Description from '../Metiral/Description';
import CustomTooltip from '../Metiral/CustomTooltip';

function BlogList({ newsList }) {
    const { image_url } = useAuth()
    const formatDate = (date) => {
        const newDate = new Date(date)
        const options = { year: 'numeric', month: 'long', day: 'numeric' }
        return newDate.toLocaleDateString('en-US', options)
    }
    const timeToRead = (text) => {
        const wordsPerMinute = 200;
        const words = text.split(" ").length;
        const minutes = words / wordsPerMinute;
        return `${Math.ceil(minutes)} min Read`;
    }
    return (
        <section className="blog-area blog-grid-area mt-5">
            <div className="container">
                <div className="row justify-content-between flex-xl-row-reverse">
                    <div className="col-12">
                        <div className="row row-gutter-70">
                            {newsList?.map((item, index) => {
                                return (
                                    <div className="col-sm-6 col-lg-3 col-xl-3">
                                        <Link to={`/news-detail/${item?._id}`}>
                                            <div className="post-item listnews-card">
                                                <div>
                                                    <img style={{ objectFit: "cover", width: '100%', height: "200px" }} src={item?.image} alt="Image" />
                                                </div>
                                                <div className="content">
                                                    <div className="author mt-3">By Admin</div>
                                                    <CustomTooltip
                                                        title={item?.title}
                                                        placement='top'>
                                                        <h4 className="title">{item?.title}</h4>
                                                    </CustomTooltip>
                                                    <p className='desc'>
                                                        <div dangerouslySetInnerHTML={{ __html: item?.description }} />
                                                    </p>
                                                    <div className="meta">
                                                        <span className="post-date">{formatDate(item?.createdAt)}</span>
                                                        <span className="dots" />
                                                        <span className="post-time">10 min read</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                )
                            })}

                            {/* <div className="col-12 text-left">
                                <div className="pagination-area">
                                    <nav>
                                        <ul className="page-numbers d-inline-flex">
                                            <li>
                                                <a className="page-number active" href="blog.html">1</a>
                                            </li>
                                            <li>
                                                <a className="page-number" href="blog.html">2</a>
                                            </li>
                                            <li>
                                                <a className="page-number" href="blog.html">3</a>
                                            </li>
                                            <li>
                                                <a className="page-number" href="blog.html">4</a>
                                            </li>
                                            <li>
                                                <a className="page-number next" href="blog.html">
                                                    <FaArrowRight />
                                                </a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div> */}
                        </div>
                    </div>
                    {/* <div className="col-xl-4">
                        <div className="blog-sidebar blog-sidebar-left">
                       
                            <div className="widget-item">
                                <div className="widget-title">
                                    <h3 className="title">Recent Post</h3>
                                </div>
                                <div className="widget-body">
                                    <div className="widget-post">
                                        <div className="widget-blog-post">
                                            <div className="thumb">
                                                <Link to="/news-detail"><img src="assets/img/blog/s1.jpg" alt="Image" width={71} height={70} /></Link>
                                            </div>
                                            <div className="content">
                                                <h4><Link to="/news-detail">This includes shipment <br />of raw materials.</Link></h4>
                                                <div className="meta">
                                                    <span className="post-date"><i className="icofont-ui-calendar" /> 10 August, 2022</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="widget-blog-post">
                                            <div className="thumb">
                                                <Link to="/news-detail"><img src="assets/img/blog/s2.jpg" alt="Image" width={71} height={70} /></Link>
                                            </div>
                                            <div className="content">
                                                <h4><Link to="/news-detail">All of these amazing <br />features come price.</Link></h4>
                                                <div className="meta">
                                                    <span className="post-date"><i className="icofont-ui-calendar" /> 18 August, 2022</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="widget-blog-post">
                                            <div className="thumb">
                                                <Link to="/news-detail"><img src="assets/img/blog/s3.jpg" alt="Image" width={71} height={70} /></Link>
                                            </div>
                                            <div className="content">
                                                <h4><Link to="/news-detail">This includes shipment <br />of raw materials.</Link></h4>
                                                <div className="meta">
                                                    <span className="post-date"><i className="icofont-ui-calendar" /> 19 August, 2022</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="widget-blog-post">
                                            <div className="thumb">
                                                <Link to="/news-detail"><img src="assets/img/blog/s4.jpg" alt="Image" width={71} height={70} /></Link>
                                            </div>
                                            <div className="content">
                                                <h4><Link to="/news-detail">All of these amazing <br />features come price.</Link></h4>
                                                <div className="meta">
                                                    <span className="post-date"><i className="icofont-ui-calendar" /> 10 August, 2022</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div> */}
                </div>
            </div>
        </section>

    )
}

export default BlogList